import React from "react";
import { useDispatch } from "react-redux";
import { clearFilters } from "@app/store/filtersSlice";
import { BlueColor } from "@app/styles/color-palette";
import { NotFoundOffersProps } from "./types";
import classes from "./catalog-list.module.scss";

const NotFoundOffers: React.FC<NotFoundOffersProps> = ({
    showResetFiltersWhenNoData,
    onFilterChanged
}) => {
    const dispatch = useDispatch();

    return (
        <div className={classes.Error}>
            По данным критериям не нашлось объявлений.{" "}
            {showResetFiltersWhenNoData && (
                <>
                    <br />
                    <a
                        style={{
                            color: BlueColor
                        }}
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            dispatch(clearFilters());
                            onFilterChanged?.();
                        }}
                    >
                        Сбросить фильтр?
                    </a>
                </>
            )}
        </div>
    );
};

export default NotFoundOffers;